<template>
  <div id="bp" class="animated fadeInRight" :style="{ animationDuration: '3s' }">
    <div id="bpd">
      <span>变频柜说明下载</span>
      <ul>
        <li v-for="(link, index) in downloadLinks" :key="index">
          <a :href="link.url">{{ link.title }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';

// 定义下载链接数据
const downloadLinks = ref([
  { title: '单台+点动(壁挂)变频调速柜操作说明', url: '../../../static/file/单台+点动(壁挂)变频调速柜操作说明.pdf' },
  { title: '单台+点动(落地)变频调速柜操作说明', url: '../../../static/file/单台+点动(落地)变频调速柜操作说明.pdf' },
  { title: '单台+手动(壁挂)变频调速柜操作说明', url: '../../../static/file/单台+手动(壁挂)变频调速柜操作说明.pdf' },
  { title: '单台+手动(落地)变频调速柜操作说明', url: '../../../static/file/单台+手动(落地)变频调速柜操作说明.pdf' },
  { title: '单台风机控制柜操作说明', url: '../../../static/file/单台风机控制柜操作说明.pdf' },
  { title: '双排控制柜操作说明', url: '../../../static/file/双排控制柜操作说明.pdf' },
  { title: '双速风机控制柜操作说明', url: '../../../static/file/双速风机控制柜操作说明.pdf' },
  { title: '双稳控制柜操作说明', url: '../../../static/file/双稳控制柜操作说明.pdf' },
  { title: '消防星三角控制柜操作说明', url: '../../../static/file/消防星三角控制柜操作说明.pdf' },
  { title: '消防直启控制柜操作说明', url: '../../../static/file/消防直启控制柜操作说明.pdf' },
  { title: '一控二+触摸屏+ABB变频调速柜操作说明', url: '../../../static/file/一控二+触摸屏+ABB变频调速柜操作说明.pdf' },
  { title: '一控二+控制器+ABB变频调速柜操作说明', url: '../../../static/file/一控二+控制器+ABB变频调速柜操作说明.pdf' },
  { title: '一控二+控制器+天川变频(壁挂)调速柜操作说明', url: '../../../static/file/一控二+控制器+天川变频(壁挂)调速柜操作说明.pdf' },
  { title: '一控二+控制器+天川变频(落地)调速柜操作说明', url: '../../../static/file/一控二+控制器+天川变频(落地)调速柜操作说明.pdf' },
  { title: '一控三+触摸屏+ABB变频调速柜操作说明', url: '../../../static/file/一控三+触摸屏+ABB变频调速柜操作说明.pdf' },
  { title: '一控三+触摸屏+天川变频调速柜操作说明', url: '../../../static/file/一控三+触摸屏+天川变频调速柜操作说明.pdf' },
  { title: '一控四+触摸屏+ABB变频调速柜操作说明', url: '../../../static/file/一控四+触摸屏+ABB变频调速柜操作说明.pdf' },
  { title: '一控四+触摸屏+天川变频调速柜操作说明', url: '../../../static/file/一控四+触摸屏+天川变频调速柜操作说明.pdf' }
]);
</script>

<style scoped>
#bp {
  padding-top: 20px;
}

#bpd span {
  color: snow;
}

a {
  color: snow;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  margin-bottom: 5px;
}

@media (min-width: 340px) {
  #bpd {
    font-size: 13px;
  }
}

@media (min-width: 768px) {
  #bpd {
    font-size: 20px;
  }
}

@media (min-width: 992px) {
  #bpd {
    font-size: 20px;
  }
}

@media (min-width: 1200px) {
  #bpd {
    font-size: 22px;
  }
}
</style>